/**
 * Portal Manta · calcPraticabilidade
 * Extraído de App.jsx v29.3 (via AST)
 */
import React, { useState, useEffect, useMemo, useCallback, Fragment, memo } from 'react';
import { calcKmUrbano, extKm } from '../../globals.js';
import { CONTEXTO_LOTES } from '../../data/contexto-lotes.js';

const calcPraticabilidade = (lote) => {
  const ctx = CONTEXTO_LOTES[lote.k] || {};
  const ext = extKm(lote);
  const km_u = calcKmUrbano(lote);
  const pct_urb = ext>0 ? km_u/ext*100 : 0;

  // Geo: NSPT 30+ → 100; 10 → 30
  const nspt = ctx.nspt_medio_oae||20;
  const geo = Math.max(0, Math.min(100, 30 + (nspt-10)*3.5));

  // Hidro: 1200 mm/ano → 80; 2400 → 30
  const pluv = ctx.pluv_mm_ano||1500;
  const hidro = Math.max(0, Math.min(100, 110 - pluv/24));

  // Fundiário: 0% urbano → 100; 30%+ → 30
  const fund = Math.max(0, Math.min(100, 100 - pct_urb*2.3));

  // Construtivo: peso topografia (montanhoso ruim) + OAE/km
  const topo = ctx.topo||{plano:50,ondulado:40,montanhoso:10};
  const oaes_un = (lote.dados_manta?.obras_per?.oaes||[]).length;
  const oae_por_km = ext>0 ? oaes_un/ext : 0;
  const fator_topo = topo.plano*1.0 + topo.ondulado*0.65 + topo.montanhoso*0.25;
  const fator_oae = Math.max(0, 100 - oae_por_km*100);
  const constr = (fator_topo*0.6 + fator_oae*0.4);

  const total = (geo*0.30 + hidro*0.20 + fund*0.20 + constr*0.30);
  return {total:Math.round(total), geo:Math.round(geo), hidro:Math.round(hidro), fund:Math.round(fund), constr:Math.round(constr)};
};

export { calcPraticabilidade };
export default calcPraticabilidade;
